import ActionArea from '@/features/common/components/Overview/parts/ProductItem/parts/ActionArea'
import NoteRow from '@/features/common/components/Overview/parts/ProductItem/parts/NoteRow'
import OptionList from '@/features/common/components/Overview/parts/ProductItem/parts/OptionList'
import TopRow from '@/features/common/components/Overview/parts/ProductItem/parts/TopRow'
import styles from '@/features/common/components/Overview/parts/ProductItem/styles'
import { ProductItem as ProductItemType } from '@/features/common/components/Overview/parts/ProductItem/types'
import { FC, ReactNode } from 'react'
import { Pressable, View } from 'react-native'

interface ProductItemProps {
    productItem: ProductItemType
    TailComponent?: ReactNode
    compact?: boolean
    expanded?: boolean
    onToggle?: () => void
    testID?: string
}

const ProductItem: FC<ProductItemProps> = ({
    productItem,
    TailComponent,
    compact = false,
    expanded,
    onToggle,
    testID,
}) => {
    const { name, quantity, price, addons, removedIngredients, containers, note } = productItem
    const textSize = compact ? 'small' : 'normal'
    const hasTail = TailComponent !== undefined && TailComponent !== null
    const hasCollapsibleTail = hasTail && !!onToggle

    const content = (
        <>
            <TopRow name={name} quantity={quantity} price={price} compact={compact} />
            <OptionList
                addons={addons}
                removedIngredients={removedIngredients}
                containers={containers}
                textSize={textSize}
            />
            <NoteRow note={note} textSize={textSize} />
        </>
    )

    return (
        <View style={[styles.card, compact && styles.cardCompact]} testID={testID}>
            {hasCollapsibleTail ? (
                <Pressable
                    onPress={onToggle}
                    accessibilityRole="button"
                    aria-expanded={expanded}
                    testID={testID ? `${testID}-pressable` : undefined}
                >
                    {content}
                </Pressable>
            ) : (
                <View>{content}</View>
            )}
            {hasCollapsibleTail && (
                <ActionArea
                    expanded={expanded ?? false}
                    TailComponent={TailComponent}
                    testID={testID ? `${testID}-actionArea` : undefined}
                />
            )}
            {hasTail && !hasCollapsibleTail && (
                <View style={styles.actionsContent}>{TailComponent}</View>
            )}
        </View>
    )
}

export default ProductItem
